import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  // siteName: string = environment.production ? 'imtransporter.com/' : 'test.imtransporter.com';

  constructor() { }

  ngOnInit() {
  }

}
